import { MarketingShell } from '../../components/MarketingShell'
import { Seo } from '../../components/Seo'
import { Card, CardBody } from '../../components/ui/Card'
import { WaitlistCta } from '../../components/marketing/WaitlistForm'

// See Home.tsx's matching comment for why these are exported.
export const seoTitle = 'About RemindLoop'
export const seoDescription =
  'RemindLoop is a B2B pre-collection and reminder service that connects to Xero and QuickBooks (Sage coming soon, or a CSV import) to send automated WhatsApp and SMS payment reminders.'

export default function About() {
  return (
    <MarketingShell>
      <Seo title={seoTitle} description={seoDescription} path="/about" />
      <section className="mx-auto max-w-3xl px-[clamp(18px,4vw,44px)] py-[clamp(44px,7vw,88px)]">
        <h1 className="text-[clamp(30px,4.4vw,48px)] leading-[1.1] font-semibold tracking-[-0.03em]">
          About RemindLoop
        </h1>
        <p className="mt-6 text-[clamp(16px,1.5vw,18px)] leading-[1.6] text-foreground/76">
          RemindLoop is a B2B pre-collection and reminder service. Organisations import reminders —
          invoices, appointments, renewals — from CSV or Excel, or connect Xero or
          QuickBooks directly (Sage coming soon), and RemindLoop evaluates rules to send WhatsApp and SMS reminders
          automatically. It exists to take the manual chasing out of accounts receivable, so
          nothing gets missed and nobody has to remember to follow up by hand.
        </p>
        <p className="mt-4 text-[clamp(16px,1.5vw,18px)] leading-[1.6] text-foreground/76">
          We built RemindLoop around two observations from working with accounting teams: first,
          that the reminder emails built into most accounting platforms get ignored far more
          often than a WhatsApp or SMS message does, simply because people check their phone
          throughout the day and clear an inbox once. Second, that a reminder sent the moment an
          invoice happens to go overdue — regardless of the hour, or whether the client already
          paid an hour earlier — is worse than no reminder at all. RemindLoop closes both gaps: it
          reads directly from the accounting data you already have, checks it again just before
          every message so a paid invoice is never chased, and times each send around when someone is actually likely to read it.
        </p>

        {/* Added 2026-10-08 (user request: "a user should not have to
            scroll far to get to a call to action link") -- this page
            previously had zero "get started" CTAs at all, only a
            contact-email link further down. */}
        <div className="mt-8">
          <WaitlistCta
            to="/register"
            source="about"
            className="min-h-11 bg-magenta-700 px-6 py-3 text-base text-white hover:bg-magenta-800"
          >
            Join the waitlist
          </WaitlistCta>
        </div>

        <Card className="mt-10">
          <CardBody className="space-y-2 p-6">
            <h2 className="text-[20px] leading-[1.25] font-semibold">Get in touch</h2>
            <p className="text-body text-foreground/76">
              Questions about a plan, a feature, or anything else — reach out and we'll get back
              to you.
            </p>
            {/* Placeholder contact address -- replace with the real support/sales inbox. */}
            <a
              href="mailto:hello@getremindloop.com"
              className="inline-block text-[15px] font-medium text-brand-700 hover:underline"
            >
              hello@getremindloop.com
            </a>
          </CardBody>
        </Card>
      </section>
    </MarketingShell>
  )
}
